/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AbortConversationResponse,
  AuditLogListResponse,
  AuditLogResponse,
  ClientDeletePreviewResponse,
  ClientListResponse,
  ClientResponse,
  ClientUsageResponse,
  ConversationDetailResponse,
  ConversationHistoryResponse,
  ConversationListResponse,
  ConversationModelsResponse,
  ConversationResponse,
  CreateClient,
  CreateConversation,
  CreateDocumentDirectory,
  CreateOperator,
  CreateProvider,
  CrmCompanyListResponse,
  CrmLinkBody,
  CrmPrefillResponse,
  CrmReconciliationResponse,
  CrmRefreshBody,
  CrmUnlinkBody,
  DashboardSummaryResponse,
  DeleteClientBody,
  DeleteConversationBody,
  DeleteDocumentBody,
  DeleteDocumentDirectoryBody,
  DeleteOperatorBody,
  DeleteProviderBody,
  DeleteTaskBody,
  DeleteTimeEntryBody,
  DocumentDirectoryTreeResponse,
  DocumentItem,
  DocumentListResponse,
  ExportDocuments,
  FromTemplate,
  InitialOperatorSetup,
  InitialOperatorSetupResponse,
  Login,
  LoginResponse,
  OperatorListResponse,
  OperatorResponse,
  ProfileResponse,
  ProviderConnectionTestResponse,
  ProviderListResponse,
  ProviderResponse,
  RefreshToken,
  RefreshTokenResponse,
  ResetPasswordBody,
  ResetPasswordResponse,
  SendConversationMessage,
  SendConversationMessageResponse,
  SetupStatusResponse,
  TaskCommentItem,
  TaskCommentUpdate,
  TaskCreate,
  TaskItem,
  TaskListResponse,
  TaskSummaryResponse,
  TaskUpdate,
  TimeEntryCreate,
  TimeEntryItem,
  TimeEntryListResponse,
  TimeEntrySummaryResponse,
  TimeEntryUpdate,
  UpdateClientBody,
  UpdateConversation,
  UpdateDocumentDirectory,
  UpdateOperatorBody,
  UpdateProfile,
  UpdateProviderBody,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsCreate
   * @summary Create a new operator (id is the user's email)
   * @request POST:/api/operators
   * @secure
   */
  operatorsCreate = (data: CreateOperator, params: RequestParams = {}) =>
    this.request<OperatorResponse, void>({
      path: `/api/operators`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsList
   * @summary List operators
   * @request GET:/api/operators
   * @secure
   */
  operatorsList = (params: RequestParams = {}) =>
    this.request<OperatorListResponse, void>({
      path: `/api/operators`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsDetail
   * @summary Get operator by ID
   * @request GET:/api/operators/{id}
   * @secure
   */
  operatorsDetail = (id: string, params: RequestParams = {}) =>
    this.request<OperatorResponse, void>({
      path: `/api/operators/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsPartialUpdate
   * @summary Update operator
   * @request PATCH:/api/operators/{id}
   * @secure
   */
  operatorsPartialUpdate = (
    id: string,
    data: UpdateOperatorBody,
    params: RequestParams = {},
  ) =>
    this.request<OperatorResponse, void>({
      path: `/api/operators/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsDelete
   * @summary Delete operator
   * @request DELETE:/api/operators/{id}
   * @secure
   */
  operatorsDelete = (
    id: string,
    data: DeleteOperatorBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/operators/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsResetPasswordCreate
   * @summary Reset an operator's password to a server-generated random value (spec 030; self-reset rejected; revokes the target's sessions)
   * @request POST:/api/operators/{id}/reset-password
   * @secure
   */
  operatorsResetPasswordCreate = (
    id: string,
    data: ResetPasswordBody,
    params: RequestParams = {},
  ) =>
    this.request<ResetPasswordResponse, void>({
      path: `/api/operators/${id}/reset-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsAuditLogsList
   * @summary Get audit log history for an operator
   * @request GET:/api/operators/{id}/audit-logs
   * @secure
   */
  operatorsAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogResponse[], void>({
      path: `/api/operators/${id}/audit-logs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsMeList
   * @summary Get current operator profile
   * @request GET:/api/operators/me
   * @secure
   */
  operatorsMeList = (params: RequestParams = {}) =>
    this.request<ProfileResponse, void>({
      path: `/api/operators/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsMePartialUpdate
   * @summary Update current operator profile
   * @request PATCH:/api/operators/me
   * @secure
   */
  operatorsMePartialUpdate = (
    data: UpdateProfile,
    params: RequestParams = {},
  ) =>
    this.request<ProfileResponse, void>({
      path: `/api/operators/me`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Audit Logs
   * @name AuditLogsList
   * @summary List audit logs
   * @request GET:/api/audit-logs
   * @secure
   */
  auditLogsList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       */
      offset?: number;
      /**
       * Maximum number of items to return (default: 50)
       * @min 1
       * @max 100
       */
      limit?: number;
      /** Full-text search across action, entity type, entity ID and user ID */
      textSearch?: string;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., -createdAt) */
      orderBy?: string[];
      /** Dynamic field filters: id, userId, action, entityId, entityType, projectId, createdAt (value, array, or { op, value }) */
      filters?: object;
    },
    params: RequestParams = {},
  ) =>
    this.request<AuditLogListResponse, void>({
      path: `/api/audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name DashboardSummaryList
   * @summary Global dashboard summary (KPIs, agent token usage, active providers)
   * @request GET:/api/dashboard/summary
   * @secure
   */
  dashboardSummaryList = (params: RequestParams = {}) =>
    this.request<DashboardSummaryResponse, void>({
      path: `/api/dashboard/summary`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsCreate
   * @summary Create a new client
   * @request POST:/api/clients
   * @secure
   */
  clientsCreate = (data: CreateClient, params: RequestParams = {}) =>
    this.request<ClientResponse, void>({
      path: `/api/clients`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsList
   * @summary List clients (text search matches name or any channel value)
   * @request GET:/api/clients
   * @secure
   */
  clientsList = (params: RequestParams = {}) =>
    this.request<ClientListResponse, void>({
      path: `/api/clients`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsDetail
   * @summary Get client by ID
   * @request GET:/api/clients/{id}
   * @secure
   */
  clientsDetail = (id: string, params: RequestParams = {}) =>
    this.request<ClientResponse, void>({
      path: `/api/clients/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsPartialUpdate
   * @summary Update client (channels are replaced wholesale)
   * @request PATCH:/api/clients/{id}
   * @secure
   */
  clientsPartialUpdate = (
    id: string,
    data: UpdateClientBody,
    params: RequestParams = {},
  ) =>
    this.request<ClientResponse, void>({
      path: `/api/clients/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsDelete
   * @summary Hard-delete a client + every bucket row anchored to it (spec 038; super_admin only)
   * @request DELETE:/api/clients/{id}
   * @secure
   */
  clientsDelete = (
    id: string,
    data: DeleteClientBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/clients/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsUsageList
   * @summary Monthly prepaid-hours usage (pool vs the month’s billable hours; computed on read)
   * @request GET:/api/clients/{id}/usage
   * @secure
   */
  clientsUsageList = (
    id: string,
    query?: {
      /** Calendar month (YYYY-MM); defaults to the current month */
      month?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ClientUsageResponse, void>({
      path: `/api/clients/${id}/usage`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsAuditLogsList
   * @summary Get audit log history for a client
   * @request GET:/api/clients/{id}/audit-logs
   * @secure
   */
  clientsAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogResponse[], void>({
      path: `/api/clients/${id}/audit-logs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsDeletePreviewList
   * @summary Delete preview — the counts the confirm modal's warning shows (spec 038)
   * @request GET:/api/clients/{id}/delete-preview
   * @secure
   */
  clientsDeletePreviewList = (id: string, params: RequestParams = {}) =>
    this.request<ClientDeletePreviewResponse, void>({
      path: `/api/clients/${id}/delete-preview`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CRM
   * @name ClientsCrmCompaniesList
   * @summary Search Twenty companies (picker for "New client from CRM" / "Link from CRM")
   * @request GET:/api/clients/crm/companies
   * @secure
   */
  clientsCrmCompaniesList = (
    query?: {
      /** Matches company name and domain (and NIP when the workspace carries the field) */
      search?: string;
      /**
       * @max 50
       * @default 20
       */
      limit?: number;
      /** Cursor from a previous page */
      startingAfter?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CrmCompanyListResponse, void>({
      path: `/api/clients/crm/companies`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CRM
   * @name ClientsCrmCompaniesPrefillList
   * @summary Pre-fill a client from a Twenty company (identity + primary-person channels)
   * @request GET:/api/clients/crm/companies/{companyId}/prefill
   * @secure
   */
  clientsCrmCompaniesPrefillList = (
    companyId: string,
    params: RequestParams = {},
  ) =>
    this.request<CrmPrefillResponse, void>({
      path: `/api/clients/crm/companies/${companyId}/prefill`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CRM
   * @name ClientsCrmLinkCreate
   * @summary Link an unlinked client to a Twenty company (adopts the CRM identity snapshot)
   * @request POST:/api/clients/{id}/crm/link
   * @secure
   */
  clientsCrmLinkCreate = (
    id: string,
    data: CrmLinkBody,
    params: RequestParams = {},
  ) =>
    this.request<ClientResponse, void>({
      path: `/api/clients/${id}/crm/link`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CRM
   * @name ClientsCrmLinkDelete
   * @summary Detach a client from its linked CRM company (removes the link only; data and commercial state are never touched; no CRM API call)
   * @request DELETE:/api/clients/{id}/crm/link
   * @secure
   */
  clientsCrmLinkDelete = (
    id: string,
    data?: CrmUnlinkBody,
    params: RequestParams = {},
  ) =>
    this.request<ClientResponse, void>({
      path: `/api/clients/${id}/crm/link`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CRM
   * @name ClientsCrmRefreshCreate
   * @summary Manual "Refresh from CRM" — identity fields only, commercial state is never touched
   * @request POST:/api/clients/{id}/crm/refresh
   * @secure
   */
  clientsCrmRefreshCreate = (
    id: string,
    data: CrmRefreshBody,
    params: RequestParams = {},
  ) =>
    this.request<ClientResponse, void>({
      path: `/api/clients/${id}/crm/refresh`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CRM
   * @name ClientsCrmReconciliationList
   * @summary Report-only reconciliation of linked clients vs the CRM (link health + identity drift; changes nothing)
   * @request GET:/api/clients/crm/reconciliation
   * @secure
   */
  clientsCrmReconciliationList = (params: RequestParams = {}) =>
    this.request<CrmReconciliationResponse, void>({
      path: `/api/clients/crm/reconciliation`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Configured in the Twenty workspace (Settings → Webhooks). Expects the `X-Twenty-Webhook-Timestamp` / `X-Twenty-Webhook-Signature` / `X-Twenty-Webhook-Nonce` headers. 404 when no CRM provider with a webhook secret is active; 401 on invalid signature/timestamp; 200 (fast) on accept. Replayed deliveries are deduplicated.
   *
   * @tags CRM
   * @name WebhooksTwentyCreate
   * @summary Twenty webhook receiver (HMAC-verified, public; audit-only in v1)
   * @request POST:/api/webhooks/twenty
   * @secure
   */
  webhooksTwentyCreate = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/webhooks/twenty`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Providers
   * @name ProvidersCreate
   * @summary Create a new provider (sensitive config fields are encrypted at rest)
   * @request POST:/api/providers
   * @secure
   */
  providersCreate = (data: CreateProvider, params: RequestParams = {}) =>
    this.request<ProviderResponse, void>({
      path: `/api/providers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Providers
   * @name ProvidersList
   * @summary List providers (filters: providerType, apiType; text search over name)
   * @request GET:/api/providers
   * @secure
   */
  providersList = (params: RequestParams = {}) =>
    this.request<ProviderListResponse, void>({
      path: `/api/providers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Providers
   * @name ProvidersDetail
   * @summary Get provider by ID (sensitive config fields masked)
   * @request GET:/api/providers/{id}
   * @secure
   */
  providersDetail = (id: string, params: RequestParams = {}) =>
    this.request<ProviderResponse, void>({
      path: `/api/providers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Providers
   * @name ProvidersPartialUpdate
   * @summary Update provider (blank sensitive fields keep the existing value)
   * @request PATCH:/api/providers/{id}
   * @secure
   */
  providersPartialUpdate = (
    id: string,
    data: UpdateProviderBody,
    params: RequestParams = {},
  ) =>
    this.request<ProviderResponse, void>({
      path: `/api/providers/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Providers
   * @name ProvidersDelete
   * @summary Delete provider (admin only; never deletes stored objects)
   * @request DELETE:/api/providers/{id}
   * @secure
   */
  providersDelete = (
    id: string,
    data: DeleteProviderBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/providers/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Providers
   * @name ProvidersTestCreate
   * @summary Zero-side-effect connection test (telegram getMe / SMTP verify / local probe / S3 ListObjectsV2)
   * @request POST:/api/providers/{id}/test
   * @secure
   */
  providersTestCreate = (id: string, params: RequestParams = {}) =>
    this.request<ProviderConnectionTestResponse, void>({
      path: `/api/providers/${id}/test`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Providers
   * @name ProvidersActivateCreate
   * @summary Set this provider active for its (providerType, apiType), deactivating the previous one
   * @request POST:/api/providers/{id}/activate
   * @secure
   */
  providersActivateCreate = (id: string, params: RequestParams = {}) =>
    this.request<ProviderResponse, void>({
      path: `/api/providers/${id}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Providers
   * @name ProvidersAuditLogsList
   * @summary Get audit log history for a provider
   * @request GET:/api/providers/{id}/audit-logs
   * @secure
   */
  providersAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogResponse[], void>({
      path: `/api/providers/${id}/audit-logs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsCreate
   * @summary Create a new agent conversation (anchored to a client)
   * @request POST:/api/conversations
   * @secure
   */
  conversationsCreate = (
    data: CreateConversation,
    params: RequestParams = {},
  ) =>
    this.request<ConversationResponse, void>({
      path: `/api/conversations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsList
   * @summary List conversations (filters: clientId, status; textSearch over title)
   * @request GET:/api/conversations
   * @secure
   */
  conversationsList = (params: RequestParams = {}) =>
    this.request<ConversationListResponse, void>({
      path: `/api/conversations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsModelsList
   * @summary Model and thinking-level catalog from the configured pi ModelRuntime (built-in + custom models.json providers)
   * @request GET:/api/conversations/models
   * @secure
   */
  conversationsModelsList = (params: RequestParams = {}) =>
    this.request<ConversationModelsResponse, void>({
      path: `/api/conversations/models`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsDetail
   * @summary Get conversation details (includes usage summary)
   * @request GET:/api/conversations/{id}
   * @secure
   */
  conversationsDetail = (id: string, params: RequestParams = {}) =>
    this.request<ConversationDetailResponse, void>({
      path: `/api/conversations/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsPartialUpdate
   * @summary Update conversation (optimistic locking via version)
   * @request PATCH:/api/conversations/{id}
   * @secure
   */
  conversationsPartialUpdate = (
    id: string,
    data: UpdateConversation,
    params: RequestParams = {},
  ) =>
    this.request<ConversationResponse, void>({
      path: `/api/conversations/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsDelete
   * @summary Delete a conversation (owner-only; hard delete, children cascade, 409 while a turn is running)
   * @request DELETE:/api/conversations/{id}
   * @secure
   */
  conversationsDelete = (
    id: string,
    data: DeleteConversationBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/conversations/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsMessagesCreate
   * @summary Send a message to the agent (streams over WS; queued when busy)
   * @request POST:/api/conversations/{id}/messages
   * @secure
   */
  conversationsMessagesCreate = (
    id: string,
    data: SendConversationMessage,
    params: RequestParams = {},
  ) =>
    this.request<SendConversationMessageResponse, void>({
      path: `/api/conversations/${id}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsMessagesList
   * @summary Page of conversation history (newest first; pi entries mapped to presentable shapes)
   * @request GET:/api/conversations/{id}/messages
   * @secure
   */
  conversationsMessagesList = (
    id: string,
    query?: {
      limit?: number;
      offset?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ConversationHistoryResponse, void>({
      path: `/api/conversations/${id}/messages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Conversations
   * @name ConversationsAbortCreate
   * @summary Abort the running agent turn (if any)
   * @request POST:/api/conversations/{id}/abort
   * @secure
   */
  conversationsAbortCreate = (id: string, params: RequestParams = {}) =>
    this.request<AbortConversationResponse, void>({
      path: `/api/conversations/${id}/abort`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsList
   * @summary List documents (client docs via ?clientId=, global templates via ?scope=template; ?search= filter)
   * @request GET:/api/documents
   * @secure
   */
  documentsList = (
    query?: {
      clientId?: string;
      scope?: "template";
      /** Text search over title and markdown content */
      search?: string;
      /** Direct-member directory filter: a folder id (dir_...), or "root" for the client root (absent = no filter) */
      directoryId?: string;
      /** With a folder directoryId: also return the documents of all subfolders (subtree search). With "root": all of the client’s documents. Default false. */
      includeSubdirectories?: boolean;
      /** @min 0 */
      offset?: number;
      /** @min 1 */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<DocumentListResponse, void>({
      path: `/api/documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsCreate
   * @summary Create a document (multipart: markdown content or file; omit clientId for a global template)
   * @request POST:/api/documents
   * @secure
   */
  documentsCreate = (
    data: {
      /** Client id for client documents; omit to create a global template (requires document_templates:write) */
      clientId?: string;
      /** Document title */
      title: string;
      /** Optional free-form notes */
      notes?: string | null;
      /** Markdown content — exactly one of content or the file part */
      content?: string | null;
      /** Owning folder id (dir_...); on update, the literal "root" moves the document to the client root (absent = no move) */
      directoryId?: string;
      /**
       * File to store — exactly one of content or the file part (max 20 MB)
       * @format binary
       */
      file?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<DocumentItem, void>({
      path: `/api/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsFromTemplateCreate
   * @summary Create a client document from a global template (copies title/content)
   * @request POST:/api/documents/from-template
   * @secure
   */
  documentsFromTemplateCreate = (
    data: FromTemplate,
    params: RequestParams = {},
  ) =>
    this.request<DocumentItem, void>({
      path: `/api/documents/from-template`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsFromAudioCreate
   * @summary Import an audio recording as a transcript document (multipart: audio part + fields; 201 with status "processing")
   * @request POST:/api/documents/from-audio
   * @secure
   */
  documentsFromAudioCreate = (
    data: {
      /**
       * Audio file (max 250 MB by default; formats = the active ASR provider supported list)
       * @format binary
       */
      audio: File;
      /** Client the new transcript document belongs to (required) */
      clientId: string;
      /** Document title (defaults to the file name without extension) */
      title?: string;
      /** Owning folder id (dir_...); absent = the client root */
      directoryId?: string;
      /** Language hint (v1 form: 'pl' / 'en'; absent = auto) */
      language?: string;
      /** Speaker diarization: "true" / "false" (default true) */
      diarize?: string;
      /** Generate the meeting note when the transcript becomes ready (spec 035, amendment 2026-09-29): "true" / "false" (default false) */
      note?: string;
      /** Explicit ASR apiType (absent = auto — the single active provider) */
      apiType?:
        | "azure"
        | "deepgram"
        | "elevenlabs"
        | "assemblyai"
        | "speechmatics"
        | "soniox";
    },
    params: RequestParams = {},
  ) =>
    this.request<DocumentItem, void>({
      path: `/api/documents/from-audio`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsRetryCreate
   * @summary Retry a failed import, or (spec 024) start/retry a file's derived-text extraction, or (spec 034) retry a failed summary
   * @request POST:/api/documents/{id}/retry
   * @secure
   */
  documentsRetryCreate = (id: string, params: RequestParams = {}) =>
    this.request<DocumentItem, void>({
      path: `/api/documents/${id}/retry`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsSummaryRegenerateCreate
   * @summary Regenerate the summary + suggested title (spec 034) — for "ready" and "failed" summaries with a ready derived text
   * @request POST:/api/documents/{id}/summary/regenerate
   * @secure
   */
  documentsSummaryRegenerateCreate = (id: string, params: RequestParams = {}) =>
    this.request<DocumentItem, void>({
      path: `/api/documents/${id}/summary/regenerate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsNotesRegenerateCreate
   * @summary Regenerate the meeting note (spec 035) — for "ready" and "failed" notes; 409 while processing / without a note / without source content
   * @request POST:/api/documents/{id}/notes/regenerate
   * @secure
   */
  documentsNotesRegenerateCreate = (id: string, params: RequestParams = {}) =>
    this.request<DocumentItem, void>({
      path: `/api/documents/${id}/notes/regenerate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsNotesCreate
   * @summary Create the meeting note for this document (spec 035) — a separate native note document, generated from the document's content by the LLM; 409 for templates / not-ready / no content / an existing note
   * @request POST:/api/documents/{id}/notes
   * @secure
   */
  documentsNotesCreate = (id: string, params: RequestParams = {}) =>
    this.request<DocumentItem, void>({
      path: `/api/documents/${id}/notes`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsExportCreate
   * @summary Export client documents as .md or .zip (v1 format: md only; merge is markdown-only)
   * @request POST:/api/documents/export
   * @secure
   */
  documentsExportCreate = (data: ExportDocuments, params: RequestParams = {}) =>
    this.request<Blob, void>({
      path: `/api/documents/export`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsDetail
   * @summary Get a document by id
   * @request GET:/api/documents/{id}
   * @secure
   */
  documentsDetail = (id: string, params: RequestParams = {}) =>
    this.request<DocumentItem, void>({
      path: `/api/documents/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsPartialUpdate
   * @summary Update a document (multipart; version for optimistic locking; file replace or content switch)
   * @request PATCH:/api/documents/{id}
   * @secure
   */
  documentsPartialUpdate = (
    id: string,
    data: {
      /** Client id for client documents; omit to create a global template (requires document_templates:write) */
      clientId?: string;
      /** Document title */
      title?: string;
      /** Optional free-form notes */
      notes?: string | null;
      /** Markdown content — exactly one of content or the file part */
      content?: string | null;
      /** Owning folder id (dir_...); on update, the literal "root" moves the document to the client root (absent = no move) */
      directoryId?: string;
      /**
       * File to store — exactly one of content or the file part (max 20 MB)
       * @format binary
       */
      file?: File;
      /** Current document version for optimistic locking (required) */
      version?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<DocumentItem, void>({
      path: `/api/documents/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsDelete
   * @summary Delete a client document (admin only; hard delete, templates 409-blocked, storage object removed best-effort)
   * @request DELETE:/api/documents/{id}
   * @secure
   */
  documentsDelete = (
    id: string,
    data: DeleteDocumentBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/documents/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsDownloadList
   * @summary Download a document (markdown as .md, files from the storage provider; always Content-Disposition: attachment)
   * @request GET:/api/documents/{id}/download
   * @secure
   */
  documentsDownloadList = (id: string, params: RequestParams = {}) =>
    this.request<Blob, void>({
      path: `/api/documents/${id}/download`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsAuditLogsList
   * @summary Get audit log history for a document
   * @request GET:/api/documents/{id}/audit-logs
   * @secure
   */
  documentsAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogResponse[], void>({
      path: `/api/documents/${id}/audit-logs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentDirectories
   * @name DocumentDirectoriesList
   * @summary List a client’s document folder tree (nested, with direct document counts)
   * @request GET:/api/document-directories
   * @secure
   */
  documentDirectoriesList = (
    query: {
      clientId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DocumentDirectoryTreeResponse, void>({
      path: `/api/document-directories`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentDirectories
   * @name DocumentDirectoriesCreate
   * @summary Create a folder in a client document tree
   * @request POST:/api/document-directories
   * @secure
   */
  documentDirectoriesCreate = (
    data: CreateDocumentDirectory,
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/api/document-directories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentDirectories
   * @name DocumentDirectoriesPartialUpdate
   * @summary Rename and/or move a folder (version-locked; parentId null = client root)
   * @request PATCH:/api/document-directories/{id}
   * @secure
   */
  documentDirectoriesPartialUpdate = (
    id: string,
    data: UpdateDocumentDirectory,
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/api/document-directories/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentDirectories
   * @name DocumentDirectoriesDelete
   * @summary Delete an empty folder (version-locked; 409 while it contains documents or subfolders)
   * @request DELETE:/api/document-directories/{id}
   * @secure
   */
  documentDirectoriesDelete = (
    id: string,
    data: DeleteDocumentDirectoryBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/document-directories/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Time Entries
   * @name TimeEntriesList
   * @summary List a client’s time entries (clientId required; operatorId / taskId / billable / from–to / textSearch filters; rows embed operatorName + taskTitle + billableHours)
   * @request GET:/api/time-entries
   * @secure
   */
  timeEntriesList = (
    query: {
      /** Client whose log is listed (required) */
      clientId: string;
      operatorId?: string;
      /** Only entries related to this task (spec 019 amendment 2026-09-11) */
      taskId?: string;
      /** Only rows with billable_hours > 0 (spec 019 amendment 2026-09-14) */
      billable?: boolean;
      /**
       * ISO date (yyyy-MM-dd), inclusive
       * @format date
       */
      from?: string;
      /**
       * ISO date (yyyy-MM-dd), inclusive
       * @format date
       */
      to?: string;
      /** Case-insensitive search over description */
      textSearch?: string;
      /** @min 0 */
      offset?: number;
      /** @min 1 */
      limit?: number;
      /** Field to sort by ("-" prefix for descending; default -date, -createdAt) */
      orderBy?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TimeEntryListResponse, void>({
      path: `/api/time-entries`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Time Entries
   * @name TimeEntriesCreate
   * @summary Create a time entry (clientId required; unknown clientId / operatorId / taskId, or an taskId from another client → 400)
   * @request POST:/api/time-entries
   * @secure
   */
  timeEntriesCreate = (data: TimeEntryCreate, params: RequestParams = {}) =>
    this.request<TimeEntryItem, void>({
      path: `/api/time-entries`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Time Entries
   * @name TimeEntriesSummaryList
   * @summary Range aggregation for one client (totalHours, byOperator, byDay; from/to default to the current calendar month)
   * @request GET:/api/time-entries/summary
   * @secure
   */
  timeEntriesSummaryList = (
    query: {
      /** Client whose log is summarized (required) */
      clientId: string;
      /**
       * ISO date (yyyy-MM-dd), inclusive (default: first day of the current calendar month)
       * @format date
       */
      from?: string;
      /**
       * ISO date (yyyy-MM-dd), inclusive (default: last day of the current calendar month)
       * @format date
       */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TimeEntrySummaryResponse, void>({
      path: `/api/time-entries/summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Time Entries
   * @name TimeEntriesDetail
   * @summary Get a time entry by id
   * @request GET:/api/time-entries/{id}
   * @secure
   */
  timeEntriesDetail = (id: string, params: RequestParams = {}) =>
    this.request<TimeEntryItem, void>({
      path: `/api/time-entries/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Time Entries
   * @name TimeEntriesPartialUpdate
   * @summary Update a time entry (version required; clientId is immutable and not part of the contract)
   * @request PATCH:/api/time-entries/{id}
   * @secure
   */
  timeEntriesPartialUpdate = (
    id: string,
    data: TimeEntryUpdate,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntryItem, void>({
      path: `/api/time-entries/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Time Entries
   * @name TimeEntriesDelete
   * @summary Delete a time entry (admin only; version-locked)
   * @request DELETE:/api/time-entries/{id}
   * @secure
   */
  timeEntriesDelete = (
    id: string,
    data: DeleteTimeEntryBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/time-entries/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Time Entries
   * @name TimeEntriesAuditLogsList
   * @summary Get audit log history for a time entry
   * @request GET:/api/time-entries/{id}/audit-logs
   * @secure
   */
  timeEntriesAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogResponse[], void>({
      path: `/api/time-entries/${id}/audit-logs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksList
   * @summary List a client’s tasks (clientId required; status / priority / assigneeId / textSearch filters; rows embed assigneeName, resolved documents, attachments and commentCount)
   * @request GET:/api/tasks
   * @secure
   */
  tasksList = (
    query: {
      /** Client whose register is listed (required) */
      clientId: string;
      status?: "open" | "in_progress" | "done" | "dropped";
      priority?: "low" | "normal" | "high";
      /** Operator who owns driving the task (oper_...) */
      assigneeId?: string;
      /** Case-insensitive search over title and description */
      textSearch?: string;
      /** @min 0 */
      offset?: number;
      /** @min 1 */
      limit?: number;
      /** Field to sort by ("-" prefix for descending; default -createdAt) */
      orderBy?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TaskListResponse, void>({
      path: `/api/tasks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksCreate
   * @summary Create a task (clientId required; unknown clientId / assigneeId / documentIds entry → 400)
   * @request POST:/api/tasks
   * @secure
   */
  tasksCreate = (data: TaskCreate, params: RequestParams = {}) =>
    this.request<TaskItem, void>({
      path: `/api/tasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksSummaryList
   * @summary Status aggregation for one client (total + byStatus; clientId required)
   * @request GET:/api/tasks/summary
   * @secure
   */
  tasksSummaryList = (
    query: {
      /** Client whose register is summarized (required) */
      clientId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TaskSummaryResponse, void>({
      path: `/api/tasks/summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksDetail
   * @summary Get a task by id (resolved related documents; ids of hard-deleted documents are silently dropped; the full comment thread, oldest first, and commentCount are embedded)
   * @request GET:/api/tasks/{id}
   * @secure
   */
  tasksDetail = (id: string, params: RequestParams = {}) =>
    this.request<TaskItem, void>({
      path: `/api/tasks/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksPartialUpdate
   * @summary Update a task (version required; clientId is immutable and not part of the contract; documentIds provided replaces the whole set, absent leaves it unchanged)
   * @request PATCH:/api/tasks/{id}
   * @secure
   */
  tasksPartialUpdate = (
    id: string,
    data: TaskUpdate,
    params: RequestParams = {},
  ) =>
    this.request<TaskItem, void>({
      path: `/api/tasks/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksDelete
   * @summary Delete a task (admin only; version-locked; attached storage objects are removed first, best effort)
   * @request DELETE:/api/tasks/{id}
   * @secure
   */
  tasksDelete = (
    id: string,
    data: DeleteTaskBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/tasks/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksAttachmentsCreate
   * @summary Attach a file to a task (multipart, single file field, 20 MB cap; stored under tasks/{clientId}/{taskId}/{attachmentId}/{fileName})
   * @request POST:/api/tasks/{id}/attachments
   * @secure
   */
  tasksAttachmentsCreate = (
    id: string,
    data: {
      /**
       * File to attach (max 20 MB)
       * @format binary
       */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<TaskItem, void>({
      path: `/api/tasks/${id}/attachments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksAttachmentsDelete
   * @summary Remove an attachment from a task (admin only; the storage object is removed first, best effort)
   * @request DELETE:/api/tasks/{id}/attachments/{attachmentId}
   * @secure
   */
  tasksAttachmentsDelete = (
    id: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/tasks/${id}/attachments/${attachmentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksCommentsCreate
   * @summary Add a comment to a task (plain text, non-empty after trim, <= 5000 chars; amendment 2026-09-15)
   * @request POST:/api/tasks/{id}/comments
   * @secure
   */
  tasksCommentsCreate = (id: string, data: any, params: RequestParams = {}) =>
    this.request<TaskCommentItem, void>({
      path: `/api/tasks/${id}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksCommentsPartialUpdate
   * @summary Edit a comment on a task (version-locked; same content rules as create; amendment 2026-09-15, part 2)
   * @request PATCH:/api/tasks/{id}/comments/{commentId}
   * @secure
   */
  tasksCommentsPartialUpdate = (
    id: string,
    commentId: string,
    data: TaskCommentUpdate,
    params: RequestParams = {},
  ) =>
    this.request<TaskCommentItem, void>({
      path: `/api/tasks/${id}/comments/${commentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksCommentsDelete
   * @summary Delete a comment from a task (admin only, no version lock; amendment 2026-09-15)
   * @request DELETE:/api/tasks/{id}/comments/{commentId}
   * @secure
   */
  tasksCommentsDelete = (
    id: string,
    commentId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/tasks/${id}/comments/${commentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksAttachmentsDownloadList
   * @summary Download an attachment (file blob; Content-Disposition: attachment — no inline rendering, spec 012)
   * @request GET:/api/tasks/{id}/attachments/{attachmentId}/download
   * @secure
   */
  tasksAttachmentsDownloadList = (
    id: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, void>({
      path: `/api/tasks/${id}/attachments/${attachmentId}/download`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksAuditLogsList
   * @summary Get audit log history for a task
   * @request GET:/api/tasks/{id}/audit-logs
   * @secure
   */
  tasksAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogResponse[], void>({
      path: `/api/tasks/${id}/audit-logs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate an operator and receive JWT access and refresh tokens.
   *
   * @tags Auth
   * @name AuthLoginCreate
   * @summary Login with credentials
   * @request POST:/api/auth/login
   */
  authLoginCreate = (data: Login, params: RequestParams = {}) =>
    this.request<LoginResponse, void>({
      path: `/api/auth/login`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Use a valid refresh token to obtain a new access and refresh token pair.
   *
   * @tags Auth
   * @name AuthRefreshCreate
   * @summary Refresh access token
   * @request POST:/api/auth/refresh
   */
  authRefreshCreate = (data: RefreshToken, params: RequestParams = {}) =>
    this.request<RefreshTokenResponse, void>({
      path: `/api/auth/refresh`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns whether the system has been configured (has at least one operator).
   *
   * @tags Setup
   * @name SetupStatusList
   * @summary Check setup status
   * @request GET:/api/setup/status
   */
  setupStatusList = (params: RequestParams = {}) =>
    this.request<SetupStatusResponse, any>({
      path: `/api/setup/status`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Creates the first operator with super_admin role. Only available when no operators exist.
   *
   * @tags Setup
   * @name SetupInitialOperatorCreate
   * @summary Create initial operator
   * @request POST:/api/setup/initial-operator
   */
  setupInitialOperatorCreate = (
    data: InitialOperatorSetup,
    params: RequestParams = {},
  ) =>
    this.request<InitialOperatorSetupResponse, void>({
      path: `/api/setup/initial-operator`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
